import React, { useState } from 'react'
import { Check } from 'react-feather';

import { ReactComponent as EXPEDITED } from "../../../assets/icons/order-expedited.svg";
import { ReactComponent as EXPEDITEDPLUS } from "../../../assets/icons/expedited-plus.svg";
import { ReactComponent as HARDCOPY } from "../../../assets/icons/order-hard-copy.svg";
import { ReactComponent as NOTRY } from "../../../assets/icons/order-notry.svg";
import { AccountType } from '../../../utility/enums';
import { PAYMENT_STATUS, ROLES, SERVICES, STATUS as statuses} from '../../../Data/statuses';

const SearchFilter = ({ type,accountType, selectedFilters, setShowModal, setStatusFilter, quote = false, isLast }) => {

 const STATUS = statuses(quote, accountType);

  const [filters, setFilters] = useState(selectedFilters);

  const handleCheck = (item) => {
    if (filters.includes(item)) {
      setFilters(f => f.filter(f => f !== item));
    } else {
      if (item === "expedited+" || item === "expedited") {
        const filtered = filters.filter(f => f !== "expedited" && f !== "expedited+");
        setFilters([...filtered, item]);
      } else {
        setFilters(f => [...f, item]);
      }
    }
  }

  const handleApply = (filters) => {
    setStatusFilter(filters);
    setShowModal("");
  }

  const handleClear = () => {
    setFilters(type === "payment" || type === "status" ? "" : []);
    setStatusFilter(type === "payment" || type === "status" ? "" : []);
    setShowModal("");
  }

  const handlePaymentClick = (item) => {
    if (filters === item) {
      setFilters("");
    } else {
      setFilters(item);
    }
  }
  const handleStatusClick = (item) => {
    if (filters === item) {
      setFilters("");
    } else {
      setFilters(item);
    }
  }

  return <div className={`accountDetailsFilterPopup ${isLast ?"xl:left-0 right-0": "left-0" }`}>
    <div className="accountDeatilsFilterItems">
      {type === "status" && STATUS.map((stat, i) => <div key={stat[0] + i} className="hardCopyCheckboxLine">
        <div className={`${filters.includes(stat[1]) && "hardCopyChecked"} hardCopyCheckbox`}>
          <Check className="hardCopyCheck" onClick={() => { handleStatusClick(stat[1]) }} style={{ opacity: filters.includes(stat[1]) ? 1 : 0 }} />
        </div>
        <p className="hardCopyCheckboxText" onClick={() => { handleStatusClick(stat[1]) }}>{stat[0]}</p>
      </div>)}
      {type === "role" && ROLES.map((stat, i) => <div key={stat[0] + i} className="hardCopyCheckboxLine">
        <div className={`${filters.includes(stat[1]) && "hardCopyChecked"} hardCopyCheckbox`}>
          <Check className="hardCopyCheck" onClick={() => { handleCheck(stat[1]) }} style={{ opacity: filters.includes(stat[1]) ? 1 : 0 }} />
        </div>
        <p className="hardCopyCheckboxText" onClick={() => { handleCheck(stat[1]) }}>{stat[0]}</p>
      </div>)}
      {type === "services" && SERVICES.map(stat => <div key={stat[0]} className="accountDetailsFilterItemWrap">
        <div className="hardCopyCheckboxLine">
          <div className={`${filters.includes(stat[1]) && "hardCopyChecked"} hardCopyCheckbox`}>
            <Check className="hardCopyCheck" onClick={() => { handleCheck(stat[1]) }} style={{ opacity: filters.includes(stat[1]) ? 1 : 0 }} />
          </div>
          <p className="hardCopyCheckboxText" onClick={() => { handleCheck(stat[1]) }}>{stat[0]}</p>
        </div>
        {stat[1] === "notry" && <NOTRY />}
        {stat[1] === "expedited" && <EXPEDITED />}
        {stat[1] === "expedited+" && <EXPEDITEDPLUS />}
        {stat[1] === "hardCopy" && <HARDCOPY />}
      </div>)}
      {type === "payment" && PAYMENT_STATUS.map((stat, i) => <div key={stat[0] + i} className="hardCopyCheckboxLine">
        <div className={`${filters === stat[1] && "hardCopyChecked"} hardCopyCheckbox`}>
          <Check className="hardCopyCheck" onClick={() => { handlePaymentClick(stat[1]) }} style={{ opacity: filters === stat[1] ? 1 : 0 }} />
        </div>
        <p className="hardCopyCheckboxText" onClick={() => { handlePaymentClick(stat[1]) }}>{stat[0]}</p>
      </div>)}
      {type === "certified" && [["Certified", true], ["	Standard", false]].map((stat, i) => <div key={stat[0] + i} className="hardCopyCheckboxLine">
        <div className={`${filters.includes(stat[1]) && "hardCopyChecked"} hardCopyCheckbox`}>
          <Check className="hardCopyCheck" onClick={() => { handleCheck(stat[1]) }} style={{ opacity: filters.includes(stat[1]) ? 1 : 0 }} />
        </div>
        <p className="hardCopyCheckboxText" onClick={() => { handleCheck(stat[1]) }}>{stat[0]}</p>
      </div>)}
    </div>

    <div className="accountDetailsFilterPopupBtns">
      <button className="accountOrderBtn accountClearBtn" onClick={() => { handleClear() }}>Clear</button>
      <button disabled={filters.length === 0} className="accountOrderBtn" onClick={() => { handleApply(filters) }}>Apply</button>
    </div>


  </div>
}

export default SearchFilter;